import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useDarkMode } from '../contexts/DarkModeContext';

export default function DarkModeToggle() {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <button
      onClick={toggleDarkMode}
      className="relative inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
      aria-label="Toggle dark mode"
    >
      <div className="relative w-10 h-5 bg-gray-300 dark:bg-gray-600 rounded-full transition-colors">
        <div
          className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full transition-transform duration-300 ${
            isDarkMode ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </div>
      {isDarkMode ? (
        <Moon className="w-4 h-4 text-gray-300" />
      ) : (
        <Sun className="w-4 h-4 text-gray-700" />
      )}
    </button>
  );
}
